/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useEffect, useContext } from 'react'
import { dateTimeCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo, getEnvConfig, getPermitActions } from 'core'
import {
  getUnitNameMap,
  getUtilityUnitsMap,
  getCompanyNameMap,
  getUserCompany,
  getValidYearRange,
} from 'core/selectors'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import {
  getTpsUnitMappingInfo,
  getTpsMaDataImport,
  importTpsMaDataImport,
} from 'api/pgads.js'
import { message, Select, DatePicker, Button, Input, Tabs } from 'antd'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'

import R from 'ramda'

import { isValidYearRange, rowHeaderRender } from 'core/utils'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
const title = 'Import MA Data (TPS)'
const TpsImportMaData = ({
  unitNameMap,
  // utilityNameMap,
  apiTargetInfo,
  validYearRange,
}) => {
  const { setError } = useContext(ErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const [activeKey, setActiveKey] = useState('dataSet1')

  const [fuzzyFilter, setFuzzyFilter] = useState('')

  const [maDataSet1data, setMaDataSet1Data] = useState([])
  const [maDataSet2data, setMaDataSet2Data] = useState([])
  const [maDataSet3data, setMaDataSet3Data] = useState([])
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const [units, setUnits] = useState([])
  const [elementNameToUnitIdMap, setElementNameToUnitIdMap] = useState({})
  const [selectedUnits, setSelectedUnits] = useState('')

  useEffect(
    _ => {
      getTpsUnitMappingInfo(apiTargetInfo).fork(setError, data => {
        setUnits(data)

        const transformedOptions = R.compose(
          R.fromPairs,
          R.map(d => [d.elementName, d.unitId])
        )(data)

        setElementNameToUnitIdMap(transformedOptions)
      })
    },
    [apiTargetInfo, setError]
  )

  const retrieve = () => {
    const isValid = isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) {
      message.warning('Please,Select valid date range!')
      return
    }
    if (selectedUnits.length === 0) {
      message.warning('Please,Select location')
      return
    }
    setSpinning(true)
    getTpsMaDataImport(apiTargetInfo)(
      selectedDateRangePicker[0],
      selectedDateRangePicker[1],
      selectedUnits
    ).fork(setError, data => {
      setSpinning(false)

      setMaDataSet1Data(data.maDataSet1)
      setMaDataSet2Data(data.maDataSet2)
      setMaDataSet3Data(data.maDataSet3)
      setActiveKey('dataSet1')
    })
  }

  const importData = () => {
    const isValid = isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) {
      message.warning('Please,Select valid date range!')
      return
    }
    if (selectedUnits.length === 0) {
      message.warning('Please,Select location!')
      return
    }
    message.info('Data is importing, please check after some time!')
    // setSpinning(true)
    importTpsMaDataImport(apiTargetInfo)(
      selectedDateRangePicker[0],
      selectedDateRangePicker[1],
      selectedUnits
    ).fork(setError, () => {
      // message.success('Data imported successfully!')
      // setSpinning(false)
      // retrieve()
    })
  }

  const maDataSet1Headers = [
    // unitIdHeader,
    strCol({
      ident: 'Unit',
      display: 'Unit',
      width: 350,
      dataGetter: ({ rowData }) => {
        return unitNameMap[elementNameToUnitIdMap[rowData.elementName]]
      },
    }),
    strCol({
      ident: 'elementName',
      display: 'Element Name',
      width: 350,
      isKey: true,
    }),
    dateTimeCol({
      ident: 'transdate',
      display: 'DateTime (Local)',
      width: 350,
    }),
    numCol({
      ident: 'maxRuntime',
      display: 'Maximum Runtime',
      width: 350,
    }),
    numCol({
      ident: 'hotStupcost',
      display: 'Hot Startup Cost',
      width: 350,
    }),
    numCol({
      ident: 'maxDailyEnrg',
      display: 'Max. Daily Energy',
      width: 350,
    }),
    numCol({
      ident: 'maxWklyStarts',
      display: 'Max. Weekly Starts',
      width: 350,
    }),
    numCol({
      ident: 'interStupCost',
      display: 'Intermediate Startup Cost',
      width: 350,
    }),
    numCol({
      ident: 'maxDailyStarts',
      display: 'Max. Daily Starts',
      width: 350,
    }),
    numCol({
      ident: 'maxWklyEnrg',
      display: 'Max. Weekly Energy',
      width: 350,
    }),
    numCol({
      ident: 'hotToColdTime',
      display: 'Hot to Cold Time',
      width: 350,
    }),
    numCol({
      ident: 'minDownTime',
      display: 'Min. Down Time',
      width: 350,
    }),
    numCol({
      ident: 'minRunTime',
      display: 'Min. Run Time',
      width: 350,
    }),
    numCol({
      ident: 'hotToInterTime',
      display: 'Hot To Intermediate Time',
      width: 350,
    }),
    numCol({
      ident: 'coldStupCost',
      display: 'Cold Startup Cost',
      width: 350,
    }),
    numCol({
      ident: 'fuelPrice',
      display: 'Fuel Price',
      width: 350,
    }),
    //   utilityHeader,
    modifierCol,
    modifiedDateCol,
  ]

  const maDataSet2Headers = [
    // unitIdHeader,
    strCol({
      ident: 'Unit',
      display: 'Unit',
      width: 350,
      dataGetter: ({ rowData }) => {
        return unitNameMap[elementNameToUnitIdMap[rowData.elementName]]
      },
    }),
    strCol({
      ident: 'elementName',
      display: 'Element Name',
      width: 350,
      isKey: true,
    }),
    dateTimeCol({
      ident: 'transdate',
      display: 'DateTime (Local)',
      width: 350,
    }),
    dateTimeCol({
      ident: 'transdateGmt',
      display: 'Transdate (GMT)',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'rtExeEnMwh',
      display: 'RT_EXE_EN MWH',
      width: 350,
    }),
    numCol({
      ident: 'rtSetpointMw',
      display: 'RT_SETPOINT MW',
      width: 350,
    }),
    numCol({
      ident: 'rtMtrMwh',
      display: 'RT_MTR MWH',
      width: 350,
    }),
    numCol({
      ident: 'rtNxeEnMwh',
      display: 'RT_NXE_EN MWH',
      width: 350,
    }),
    numCol({
      ident: 'daSuppAmt',
      display: 'DA_SUPP AMT',
      width: 350,
    }),
    numCol({
      ident: 'daRegMcp',
      display: 'DA_REG MCP',
      width: 350,
    }),
    numCol({
      ident: 'rtPvMakewholeAmt',
      display: 'RT_PV_MAKEWHOLE AMT',
      width: 350,
    }),
    numCol({
      ident: 'daRegMw',
      display: 'DA_REG MCP',
      width: 350,
    }),
    numCol({
      ident: 'rtLmp',
      display: 'RT LMP',
      width: 350,
    }),
    numCol({
      ident: 'daSpinAmt',
      display: 'DA_SPIN AMT',
      width: 350,
    }),
    numCol({
      ident: 'rtSpinAmt',
      display: 'RT_SPIN AMT',
      width: 350,
    }),
    numCol({
      ident: 'daEnAmt',
      display: 'DA_EN AMT',
      width: 350,
    }),
    numCol({
      ident: 'rtRegAmt',
      display: 'RT_REG AMT',
      width: 350,
    }),
    numCol({
      ident: 'rtSuppMw',
      display: 'RT_SUPP MW',
      width: 350,
    }),
    numCol({
      ident: 'totEnAsAmt',
      display: 'TOT_EN_AS AMT',
      width: 350,
    }),
    numCol({
      ident: 'daEnMwh',
      display: 'DA_EN MWH',
      width: 350,
    }),
    numCol({
      ident: 'daRegAmt',
      display: 'DA_REG AMT',
      width: 350,
    }),
    numCol({
      ident: 'rtSpinMw',
      display: 'RT_SPIN MW',
      width: 350,
    }),
    numCol({
      ident: 'rtExeEnPrice',
      display: 'RT_EXE_EN PRICE',
      width: 350,
    }),
    numCol({
      ident: 'rtRsgDistAmt',
      display: 'RT_RSG_DIST AMT',
      width: 350,
    }),
    numCol({
      ident: 'rtNxeEnAmt',
      display: 'RT_NXE_EN AMT',
      width: 350,
    }),
    numCol({
      ident: 'rtExeEnAmt',
      display: 'RT_EXE_EN AMT',
      width: 350,
    }),
    numCol({
      ident: 'daLmp',
      display: 'DA LMP',
      width: 350,
    }),
    numCol({
      ident: 'rtRegMcp',
      display: 'RT_REG MCP',
      width: 350,
    }),
    numCol({
      ident: 'rtSuppAmt',
      display: 'RT_SUPP AMT',
      width: 350,
    }),
    numCol({
      ident: 'rtRegMw',
      display: 'RT_REG MW',
      width: 350,
    }),
    numCol({
      ident: 'daSuppMw',
      display: 'DA_SUPP MW',
      width: 350,
    }),
    numCol({
      ident: 'daRsgAmt',
      display: 'DA_RSG AMT',
      width: 350,
    }),
    numCol({
      ident: 'daSpinMw',
      display: 'DA_SPIN MW',
      width: 350,
    }),
    //   utilityHeader,
    modifierCol,
    modifiedDateCol,
  ]

  const maDataSet3Headers = [
    // unitIdHeader,
    strCol({
      ident: 'Unit',
      display: 'Unit',
      width: 350,
      dataGetter: ({ rowData }) => {
        return unitNameMap[elementNameToUnitIdMap[rowData.elementName]]
      },
    }),
    strCol({
      ident: 'elementName',
      display: 'Element Name',
      width: 350,
      isKey: true,
    }),
    dateTimeCol({
      ident: 'transdate',
      display: 'DateTime (Local)',
      width: 350,
    }),
    numCol({
      ident: 'damSpinresMw',
      display: 'Mkt DAM SpinningReserve MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'damRegMw',
      display: 'Mkt DAM Regulation MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'damRampupMw',
      display: 'Mkt DAM RampUp MWs',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'emermax',
      display: 'Emergency Max',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'offlSuppPrice',
      display: 'Offline Supp. OfferPrice',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'daRamprate',
      display: 'DA RampRate',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'regmax',
      display: 'Reg. Max',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'noloadcost',
      display: 'NoLoad Cost',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'regmin',
      display: 'Reg. Min',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg1Price',
      display: 'SEG1 PRICE',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg2Price',
      display: 'SEG2 PRICE',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg3Price',
      display: 'SEG3 PRICE',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg4Price',
      display: 'SEG4 PRICE',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg5Price',
      display: 'SEG5 PRICE',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg6Price',
      display: 'SEG6 PRICE',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg7Price',
      display: 'SEG7 PRICE',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg8Price',
      display: 'SEG8 PRICE',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg9Price',
      display: 'SEG9 PRICE',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg10Price',
      display: 'SEG10 PRICE',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'interStrupTime',
      display: 'Inter. StartupTime',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'damEnergyMw',
      display: 'Mkt. DAM EnergyMW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'emermin',
      display: 'Emergency Min',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'interNotifTime',
      display: 'Inter NotificationTime',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'regOffer',
      display: 'Reg. OfferPrice',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'hotStrupTime',
      display: 'Hot StartupTime',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg1Mw',
      display: 'SEG1 MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg2Mw',
      display: 'SEG2 MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg3Mw',
      display: 'SEG3 MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg4Mw',
      display: 'SEG4 MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg5Mw',
      display: 'SEG5 MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg6Mw',
      display: 'SEG6 MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg7Mw',
      display: 'SEG7 MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg8Mw',
      display: 'SEG8 MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg9Mw',
      display: 'SEG9 MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'seg10Mw',
      display: 'SEG10 MW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'hotNotifTime',
      display: 'Hot NotificationTime',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'coldStrupTime',
      display: 'Cold StartupTime',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'suppOfferPrice',
      display: 'Suppl. OfferPrice',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'spinOfferPrice',
      display: 'Spin OfferPrice',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'ecomax',
      display: 'Economic Max',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'damSuppResvMw',
      display: 'DAM Suppl. ReserveMW',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'damRampdownMw',
      display: 'DAM RampDownMWs',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'coldNotifTime',
      display: 'Cold NotificationTime',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'ecomin',
      display: 'Economic Min',
      width: 350,
      isKey: true,
    }),
    numCol({
      ident: 'regMileOffer',
      display: 'Reg. Mileage OfferPrice',
      width: 350,
      isKey: true,
    }),
    //   utilityHeader,
    modifierCol,
    modifiedDateCol,
  ]

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            // width: '170px',
            // minwidth: '170px',
          }}
        >
          {title}
        </Title>
        <DatePicker.RangePicker
          style={{ marginRight: '15px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDateRangePicker}
          onChange={d => {
            setSelectedDateRagePicker(d)
            setMaDataSet1Data([])
            setMaDataSet2Data([])
            setMaDataSet3Data([])
            // onCriteriaChnage()
          }}
        />

        <Button
          icon="database"
          loading={spinning}
          onClick={retrieve}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Retrieve
        </Button>
        <Button
          Style={{ marginRight: '10px' }}
          onClick={importData}
          css={{ marginLeft: '10px' }}
          icon="thunderbolt"
          type="danger"
        >
          Import
        </Button>
        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{ marginLeft: '10px', marginRight: '10px', maxWidth: '200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <Button
          Style={{ marginRight: '10px' }}
          // onClick={exportData}
          icon="export"
        >
          Export
        </Button>
      </CriteriaRow>
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateRows: 'auto',
            width: '100%',
          }}
        >
          <div
            style={{
              gridRow: '1',
            }}
          >
            <span>Select Locations: -</span>
          </div>
          <div
            style={{
              gridRow: '2',
            }}
          >
            <Select
              mode="multiple"
              allowClear
              style={{
                width: '100%',
              }}
              placeholder="Please select locations"
              onChange={value => {
                setSelectedUnits(value)

                setMaDataSet1Data([])
                setMaDataSet2Data([])
                setMaDataSet3Data([])
              }}
            >
              {units?.map((x, y) => (
                <Select.Option value={x.elementName} key={y}>
                  {x.pnodeId}-{x.elementName}
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </CriteriaRow>
      <FullHeightSizer heightOffset={300}>
        {({ height, width }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <Tabs activeKey={activeKey} onChange={setActiveKey}>
              <Tabs.TabPane
                title="MA Data Set 1"
                key="dataSet1"
                tab="MA Data Set 1"
              >
                <div style={{ height: height - 20, width: width }}>
                  <Grid
                    headerRowHeight={30}
                    height={height - 100}
                    width={width - 60}
                    headers={maDataSet1Headers}
                    data={maDataSet1data}
                    // fuzzyFilter={fuzzyFilter}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 60,
                      headerRowHeight: 30,
                    })}
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane
                title="MA Data Set 2"
                key="dataSet2"
                tab="MA Data Set 2"
              >
                <div style={{ height: height, width: width }}>
                  <Grid
                    headerRowHeight={30}
                    height={height - 100}
                    width={width - 60}
                    headers={maDataSet2Headers}
                    data={maDataSet2data}
                    setData={setMaDataSet2Data}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 60,
                      headerRowHeight: 30,
                    })}
                    // fuzzyFilter={fuzzyFilter}
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane
                title="MA Data Set 3"
                key="dataSet3"
                tab="MA Data Set 3"
              >
                <div style={{ height: height, width: width }}>
                  <Grid
                    headerRowHeight={30}
                    height={height - 100}
                    width={width - 60}
                    headers={maDataSet3Headers}
                    data={maDataSet3data}
                    setData={setMaDataSet3Data}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 60,
                      headerRowHeight: 30,
                    })}
                    // fuzzyFilter={fuzzyFilter}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  companyNameMap: getCompanyNameMap(state),
  // utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  userCompany: getUserCompany(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(TpsImportMaData)
// export default TpsImportMaData
